export const VARIATION = [
  'primary',
  'secondary',
  'success',
  'warning',
  'critical',
  'informational',
  ''
]
export const SIZE = [
  'small',
  'large',
  '',
]
